export default __webpack_public_path__ + "static/honeycomb-558dead141b83d1637c3aed327e6dd4f.svg";